import * as React from "react";
import { IconButton } from "@mui/material";
import { useModal } from "../../../../../../../../hooks/use_modal";
import { FormModal } from "../../../../../../../Components/FormModal";
import { useForm } from "../../../../../../../../hooks/use_form_v2";
import { FreeTextField } from "../../../../../../../Components/Form/FreeTextField";
import { convertAmountToFloat } from "../../../../../../../../helpers/transaction_helpers";
import { Form } from "../../../../../../../Components/Form/Form/Form";
import { ISubTransaction } from "./SubTransactionsField";
import { PurchaseDateField } from "../../../PurchaseDateField";
import { MoneyField } from "../../../../../../../Components/Form/MoneyField";
import { useTransactionFormStore } from "../../../../../../../../hooks/use_transaction_form_store";
import { validateSubTransactionForm } from "../../../../../../../../validators/transactions_details_sub_transaction";
import { toForm } from "../../../../../../../../helpers/transaction_details_sub_transactions_helpers";
import moment from "moment";

interface ISubTransactionFormProps {
    title: string;
    value?: ISubTransaction;
    onChange(value: ISubTransaction): void;
    trigger: React.ReactNode;
}

export const SubTransactionForm = ({title, value, onChange, trigger}: ISubTransactionFormProps) => {
    const { currentTransactionStore } = useTransactionFormStore();

    const {open, handleModalOpen, handleModalClose} = useModal();
    const form = useForm<ISubTransaction>(toForm(currentTransactionStore.get('purchasedAt'), value));
    const { register } = form;

    const handleSubmit = (values: ISubTransaction) => {
        const validation = validateSubTransactionForm(values);
        if (!validation.isValid()) {
            return Promise.reject(validation);
        }

        onChange({
            date: moment(values.date),
            amount: convertAmountToFloat(values.amount),
            description: values.description,
        });
        handleModalClose();

        return Promise.resolve();
    };

    return (
        <>
            <FormModal title={title} open={open} loading={false} onClose={handleModalClose}>
                <Form form={form} onSubmit={handleSubmit}>
                    <Form.Field
                        {...register('amount')}
                        type={MoneyField}
                        currency={currentTransactionStore.get('currency')}
                        gridProps={{xs: 12, md: 3}}
                    />

                    <Form.Field
                        {...register('date')}
                        type={PurchaseDateField}
                        gridProps={{xs: 12, md: 9}}
                    />

                    <Form.Field type={FreeTextField} {...register('description')} />
                </Form>
            </FormModal>

            <IconButton size="small" color="primary" onClick={handleModalOpen}>
                {trigger}
            </IconButton>
        </>
    );    
};
